import { render } from "./ExpiryField.vue?vue&type=template&id=50a6af9c"
import script from "./ExpiryField.vue?vue&type=script&lang=js"
export * from "./ExpiryField.vue?vue&type=script&lang=js"

import exportComponent from "/runner/_work/cb-checkout/cb-checkout/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__